const customSortFns = {
  semVerSort: (a, b) => a.toString().localeCompare(b.toString(), undefined, { numeric: true }) === 1 ? 1 : -1
}

export default customSortFns;